import ProjectVideo from '@/components/ProjectVideo'
import { cn, cleanString } from '@/lib/utils'
import { urlForImage } from '@/sanity/lib/image'
import { createDataAttribute } from 'next-sanity'
import Image from 'next/image'

interface ProjectMediaProps {
	type: "image" | "video"
	image?: any
	video?: any
	align?: string
	aspectRatio?: string
	caption?: string
	nudgeDown?: boolean
	documentId: string
	_key: string
}

export default function ProjectMedia({ type, image, video, align, aspectRatio = '1/1', caption, nudgeDown = false, documentId, _key }: ProjectMediaProps) {
	return (
		<div
			className={cn(`block--project-media col-span-full`, {
				"md:col-span-6 project-thumb--small" : cleanString(aspectRatio) !== "16/9",
				"md:col-start-7" : (cleanString(aspectRatio) !== "16/9" && cleanString(align) === "right"),
				"md:mt-[20vw]" : nudgeDown
			})}
			key={_key}
			data-sanity={createDataAttribute({
				id: documentId,
				type: 'project',
				path: `contentBlocks[_key=="${_key}"]`,
			}).toString()}
		>
			<div className="text-lg leading-100 group">
				<div
					className="relative rounded-[8px] overflow-clip"
					style={{ aspectRatio: cleanString(aspectRatio) }}
				>
					{(type === "image" && image) && (
						<Image
							className="w-full h-full object-cover"
							src={urlForImage(image).width(3840).url()}
							sizes={cleanString(aspectRatio) === "16/9" ? `100vw` : `(min-width: 1024px) 50vw, 100vw`}
							width={image?.asset?.metadata?.dimensions?.width}
							height={image?.asset?.metadata?.dimensions?.height}
							alt={image?.alt || ""}
							placeholder="blur"
							blurDataURL={image?.asset?.metadata?.lqip}
							quality={90}
						/>
					)}
					{(type === "video" && video) && (
						<ProjectVideo video={video} />
					)}
				</div>
				{caption && <p className="text-base text-grey dark:text-grey-dark mt-4">{caption}</p>}
			</div>
		</div>
	)
}
